import { AppDetailContext } from './appdetail-context';
import { AppDetailContextProviderProps } from './types';

const AppDetailContextProvider: React.FC<AppDetailContextProviderProps> = ({ children, ...value }) => {
  return <AppDetailContext value={value}>{children}</AppDetailContext>;
};

export default AppDetailContextProvider;
